(function () {
  var filtersRoot = document.getElementById('rv-filters');
  var grid = document.getElementById('rv-product-grid');
  var emptyState = document.getElementById('rv-empty-state');
  var resultCount = document.getElementById('rv-result-count');
  var priceFrom = resultCount ? resultCount.parentNode.querySelector('.rv-price-from') : null;
  var priceFromValue = priceFrom ? priceFrom.querySelector('strong') : null;
  if (!filtersRoot || !grid) return;

  var active = { mood: 'all', molecule: 'all', brand: 'all', type: 'all', format: 'all', potency: 'all', priceMin: 0, priceMax: 100 };

  // Normaliza para comparar: sin espacios sobrantes, sin mayúsculas y sin acentos.
  // Así "H2 " (con espacio de más) o "h2" siguen contando como H2.
  function norm(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  // Coincide si el valor del producto contiene el del filtro, no solo si es idéntico:
  // un producto con molécula "H2 Superior Blend" entra en el filtro "H2".
  function fieldMatches(cardValue, filterValue) {
    if (filterValue === 'all') return true;
    var card = norm(cardValue);
    var filter = norm(filterValue);
    if (!filter) return true;
    if (!card) return false;
    return card === filter || card.indexOf(filter) !== -1;
  }

  function matches(card) {
    if (!fieldMatches(card.dataset.molecule, active.molecule)) return false;
    if (!fieldMatches(card.dataset.brand, active.brand)) return false;
    if (!fieldMatches(card.dataset.type, active.type)) return false;
    if (!fieldMatches(card.dataset.format, active.format)) return false;
    if (!fieldMatches(card.dataset.potency, active.potency)) return false;
    if (active.mood !== 'all') {
      // Coma, punto y coma o espacio: hay productos con los efectos escritos "relax euforia social".
      var moods = (card.dataset.moods || '').split(/[\s,;]+/).map(norm);
      if (moods.indexOf(norm(active.mood)) === -1) return false;
    }

    var price = parseFloat(card.dataset.price || 0);
    if (price < active.priceMin) return false;
    if (active.priceMax < 100 && price > active.priceMax) return false;

    return true;
  }

  function apply() {
    var cards = grid.querySelectorAll('.showcase-product');
    var visible = 0;
    var minPrice = Infinity;
    cards.forEach(function (card) {
      var show = matches(card);
      card.style.display = show ? '' : 'none';
      if (show) {
        visible++;
        var p = parseFloat(card.dataset.price);
        if (p > 0 && p < minPrice) minPrice = p;
      }
    });
    if (resultCount) resultCount.textContent = visible;
    if (emptyState) emptyState.hidden = visible !== 0;

    // "precios desde X" (sale de Liquid con el mas barato de la coleccion): al filtrar
    // tiene que ser el mas barato de lo que se ve, o diria 10,30 EUR filtrando H10.
    if (priceFrom && priceFromValue) {
      priceFrom.hidden = minPrice === Infinity;
      if (minPrice !== Infinity) {
        priceFromValue.textContent = minPrice.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      }
    }

    var filterApplyBtn = document.getElementById('rv-filter-apply');
    if (filterApplyBtn) {
      filterApplyBtn.textContent = 'Ver ' + visible + ' productos';
    }
  }

  var FILTER_GROUPS = ['mood', 'molecule', 'brand', 'type', 'format', 'potency'];
  // Clave interna -> parametro de la URL. `format` viaja como `formato` (ver nota mas abajo).
  var filterToUrlKey = { mood: 'mood', molecule: 'molecule', brand: 'brand', type: 'type', format: 'formato', potency: 'potency' };
  var resetButtons = document.querySelectorAll('.js-rv-filter-reset');

  function hasActiveFilters() {
    return FILTER_GROUPS.some(function (g) { return active[g] !== 'all'; }) ||
      active.priceMin > 0 || active.priceMax < 100;
  }

  // Deja los filtros en la direccion de la pagina: sobreviven a recargar y a atras/adelante,
  // y el enlace se puede compartir. replaceState: no llena el historial con cada clic.
  function syncUrl() {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    FILTER_GROUPS.forEach(function (g) {
      var key = filterToUrlKey[g];
      if (active[g] === 'all') params.delete(key); else params.set(key, active[g]);
    });
    var qs = params.toString();
    window.history.replaceState(window.history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
  }

  function updateResetButtons() {
    var on = hasActiveFilters();
    resetButtons.forEach(function (btn) {
      if (btn.closest('#rv-empty-state')) return;
      btn.hidden = !on;
    });
  }

  function activateFilter(group, value, skipUrl) {
    active[group] = value;
    filtersRoot.querySelectorAll('[data-filter="' + group + '"]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.value === value);
    });
    apply();
    if (!skipUrl) syncUrl();
    updateResetButtons();
  }

  function resetFilters() {
    FILTER_GROUPS.forEach(function (g) { activateFilter(g, 'all', true); });
    document.querySelectorAll('.rv-dual-range').forEach(function (container) {
      var minInput = container.querySelector('input[id*="price-min"]');
      var maxInput = container.querySelector('input[id*="price-max"]');
      if (minInput) minInput.value = minInput.min || 0;
      if (maxInput) {
        maxInput.value = maxInput.max || 100;
        maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    syncUrl();
    updateResetButtons();
  }

  resetButtons.forEach(function (btn) {
    btn.addEventListener('click', resetFilters);
  });

  filtersRoot.addEventListener('click', function (e) {
    var item = e.target.closest('.filter-item');
    if (!item) return;
    activateFilter(item.dataset.filter, item.dataset.value);
  });

  document.querySelectorAll('.js-rv-filter-link').forEach(function (link) {
    link.addEventListener('click', function () {
      activateFilter(link.dataset.filter, link.dataset.value);
    });
  });

  // Deep-linking: megamenu/footer links to /collections/catalogo carry the facet in the URL
  // (?mood=relax, ?molecule=HHZ, ...) since a real page load can't run the click-time
  // activateFilter() above (that only works for same-page clicks on Home). Pre-apply whatever
  // facet is present in the query string on load, on both Home and the collection page.
  // OJO: `format` es un parametro RESERVADO de Shopify. /collections/catalogo?format=Pod
  // devuelve un 404 duro del servidor (CollectionDetailsController, text/plain "Not Found"),
  // asi que ese enlace nunca llega a cargar la pagina y este script ni se ejecuta.
  // Por eso en la URL el formato viaja como `formato` y aqui se traduce a la clave interna
  // `format`, que es la que usan los data-filter de rv-catalog.liquid y rv-collection.liquid.
  // No volver a poner `format` en un href.
  var params = new URLSearchParams(window.location.search);
  var urlKeyToFilter = {
    mood: 'mood',
    molecule: 'molecule',
    brand: 'brand',
    type: 'type',
    formato: 'format',
    potency: 'potency',
    price: 'price'
  };
  Object.keys(urlKeyToFilter).forEach(function (urlKey) {
    var value = params.get(urlKey);
    if (value) activateFilter(urlKeyToFilter[urlKey], value, true);
  });

  // Initialize all dual range sliders
  var dualRanges = document.querySelectorAll('.rv-dual-range');
  dualRanges.forEach(function(container) {
    var minInput = container.querySelector('input[id^="price-min"], input[id*="price-min"]');
    var maxInput = container.querySelector('input[id^="price-max"], input[id*="price-max"]');
    var progress = container.querySelector('.rv-dual-range__progress');
    var display = container.parentElement.querySelector('[id^="price-display"], [id*="price-display"]');

    if (!minInput || !maxInput) return;

    function updateLocalSlider(e) {
      var minVal = parseInt(minInput.value);
      var maxVal = parseInt(maxInput.value);

      if (minVal > maxVal - 5) {
        if (e && e.target === minInput) {
          minVal = maxVal - 5;
          minInput.value = minVal;
        } else {
          maxVal = minVal + 5;
          maxInput.value = maxVal;
        }
      }

      active.priceMin = minVal;
      active.priceMax = maxVal;

      var maxText = maxVal >= 100 ? '100€+' : maxVal + '€';
      if (display) {
        if (minVal === 0 && maxVal >= 100) {
          display.textContent = 'Todos';
        } else {
          display.textContent = minVal + '€ - ' + maxText;
        }
      }

      if (progress) {
        var minPercent = (minVal / 100) * 100;
        var maxPercent = (maxVal / 100) * 100;
        progress.style.left = minPercent + '%';
        progress.style.width = (maxPercent - minPercent) + '%';
        
        container.style.setProperty('--range-min', minPercent + '%');
        container.style.setProperty('--range-max', maxPercent + '%');
      }

      apply();
      updateResetButtons();
    }

    minInput.addEventListener('input', updateLocalSlider);
    maxInput.addEventListener('input', updateLocalSlider);
    updateLocalSlider();
  });

  // --- Mobile Drawer Logic ---
  var filterTrigger = document.getElementById('rv-filter-trigger');
  var filterClose = document.getElementById('rv-filter-close');
  var filterOverlay = document.getElementById('rv-filter-overlay');
  var filterApply = document.getElementById('rv-filter-apply');

  function openFilters() {
    filtersRoot.classList.add('is-open');
    if (filterOverlay) filterOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    filtersRoot.classList.remove('is-open');
    if (filterOverlay) filterOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (filterTrigger) filterTrigger.addEventListener('click', openFilters);
  if (filterClose) filterClose.addEventListener('click', closeFilters);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);
  if (filterApply) filterApply.addEventListener('click', closeFilters);

  apply();
})();
